import { DataService } from './dataService'


export const DutyAndTaxService ={
    getDutyAndTaxList: async (data) => {
        return DataService.get('/admin/duty-and-tax/get_all' , data)
    },
    editDutyAndTax: async (data) => {
        return DataService.put('/admin/duty-and-tax/update', data)
    },
	addDutyAndTax: async (data) => {
        return DataService.post('/admin/duty-and-tax/create', data)
    },
	deleteDutyAndTax: async (data) => {
        return DataService.delete('/admin/duty-and-tax/delete', data)
    },    
}